import { useToggleMaintenanceMutation } from '@/api/maintenance/maintenanceMutations';
import { getMaintenanceStatusQuery } from '@/api/maintenance/maintenanceQueries';
import { Button } from '@/components/common/Button';
import { DialogWrapper } from '@/components/common/DialogWrapper';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { DashboardTableAccordion } from '../DashboardTableAccordion';

const PLACEHOLDER_DATA = [{ id: 'maintenance' }];

export const Settings = () => {
  const [confirmMode, setConfirmMode] = useState<boolean | null>(null);

  const { data: maintenance, isLoading } = useQuery(
    getMaintenanceStatusQuery(),
  );
  const toggleMutation = useMutation(useToggleMaintenanceMutation());

  const isOn = maintenance?.maintenance;

  const handleConfirm = () => {
    if (confirmMode === null) return;
    toggleMutation.mutate(
      { mode: confirmMode },
      { onSettled: () => setConfirmMode(null) },
    );
  };

  return (
    <>
      <DashboardTableAccordion
        value="settings"
        title="Settings"
        data={PLACEHOLDER_DATA}
        customTable={
          <div>
            <p className="text-table-foreground mb-4 text-base font-light">
              Under the maintenance
            </p>
            {isLoading ? (
              <p className="text-muted-foreground text-sm">Loading...</p>
            ) : (
              <div className="flex items-center gap-3">
                <Button
                  variant={isOn ? 'primary' : 'outlinePrimary'}
                  size="md"
                  onClick={() => setConfirmMode(true)}
                >
                  On
                </Button>
                <Button
                  variant={!isOn ? 'primary' : 'outlinePrimary'}
                  size="md"
                  onClick={() => setConfirmMode(false)}
                >
                  Off
                </Button>
              </div>
            )}
          </div>
        }
      />

      <DialogWrapper
        open={confirmMode !== null}
        onOpenChange={(open) => {
          if (!open) setConfirmMode(null);
        }}
        title="Confirm maintenance mode"
        maxWidth="sm"
      >
        <p className="text-table-foreground mb-6 text-sm font-light">
          Are you sure you want to turn maintenance mode{' '}
          <span className="font-medium">{confirmMode ? 'on' : 'off'}</span>?
        </p>
        <div className="flex justify-end gap-3">
          <Button
            variant="outlinePrimary"
            size="md"
            disabled={toggleMutation.isPending}
            onClick={() => setConfirmMode(null)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="md"
            disabled={toggleMutation.isPending}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </div>
      </DialogWrapper>
    </>
  );
};
